import { render, staticRenderFns } from "./Edit_listlink.vue?vue&type=template&id=70a5037d"
import script from "./Edit_listlink.vue?vue&type=script&lang=js"
export * from "./Edit_listlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports